import EventBus from './Event';

class Toast {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.$card = this.$el.find('[data-toast-card]');
    this.$message = this.$el.find('[data-toast-msg]');

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    EventBus.on('toast', this.onToast.bind(this));
  }

  onToast(data) {
    const { message, type } = data;
    this.$message.text(message);
    this.$card.addClass(type);

    this.$el.addClass('show');
    setTimeout(() => {
      this.$el.removeClass('show');
      this.$card.removeClass(type);
      this.$message.text('');
    }, 5000);
  }

  static init() {
    $('[data-js-component="toast"]').each((i, el) => new Toast(el));
  }
}

Toast.init();
